import React from 'react';
import RankBox from './RankBox';
import { DeepPermitsChart, BizDynamicsChart } from './charts/BizClimateCharts';
import { deepPermits, bizDynamics } from './api/bizClimateData';
import { cnbcBizFriendly, legalClimate } from './api/rankBoxes';

const BizClimateView = () => {
  return (
    <>
      <div className="flex flex-wrap justify-center mb-8">
        <RankBox
          title="State Legal Climate"
          value={legalClimate?.value || 0}
          type="rank"
          rank={legalClimate?.rank}
          trend={legalClimate?.trend}
        />
        <RankBox
          title="CNBC Biz Friendliness"
          value={cnbcBizFriendly?.value || 0}
          type="rank"
          rank={cnbcBizFriendly?.rank}
          trend={cnbcBizFriendly?.trend}
        />
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow mb-8">
        <h2 className="text-xl font-semibold mb-4">Connecticut Business Dynamics</h2>
        <p className="mb-4">Quarterly trends in business activities</p>
        <BizDynamicsChart data={bizDynamics} />
      </div>
      
      <div className="bg-white p-4 rounded-lg shadow mb-8">
        <h2 className="text-xl font-semibold mb-4">DEEP Permits Completed On Time</h2>
        <p className="mb-4">Percentage of permits completed within the target timeframe by quarter</p>
        <DeepPermitsChart data={deepPermits} />
      </div>
    </>
  );
};

export default BizClimateView;